import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { Billing, BillingCustomCService } from '@eadsysteme/billingclient-v1';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BaseSelectByRealEstateDialogComponent } from '../../shared/base-select-by-real-estate-dialog.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'vex-select-billing-by-realestate-dialog',
	imports: [
		CdkDrag,
		CdkDragHandle,
		MatButton,
		MatDialogActions,
		MatDialogContent,
		MatDialogTitle,
		TranslocoDirective,
		MatIcon,
		FormsModule,
		MatFormField,
		MatLabel,
		MatOption,
		MatSelect,
		ReactiveFormsModule,
		MatSelectTrigger,
		MatError,
		MatProgressSpinner,
		MatIconButton,
	],
	templateUrl: './select-billing-by-real-estate-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './select-billing-by-real-estate-dialog.component.scss',
})
export class SelectBillingByRealEstateDialogComponent extends BaseSelectByRealEstateDialogComponent<Billing> {
	protected readonly dialogRef = inject(MatDialogRef<SelectBillingByRealEstateDialogComponent>);
	private readonly billingCustomCService = inject(BillingCustomCService);

	protected get billings() {
		return this.items;
	}

	protected get billingFc() {
		return this.itemFc;
	}

	protected fetchItems(realEstateId: string): Observable<Billing[]> {
		return this.billingCustomCService
			.getBillingsByRealEstate(this.sessionService.effectiveArea, realEstateId)
			.pipe(map((billings) => (billings ?? []).filter((billing) => billing.portalActive !== false)));
	}

	protected loadBillings(initialLoad: boolean = false): void {
		this.loadItems(initialLoad);
	}

	protected close(saved: boolean): void {
		const ret = { saved };
		if (saved) {
			ret['routeToNavigate'] = '/billing-units/' + this.billingFc.value.exportId;
		}
		this.dialogRef.close(ret);
	}
}
